import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterDataService } from './../services/master-data.service';
import { CommonMessageService } from '../services/common-message.service';
import { HumanResourceService, UserProfileService } from '../services/human-resource.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  changePasswordForm:FormGroup;
  submitted=false;
  toggleSideNav: boolean = false;
  toggleDocumentSideNav: boolean = false;
  fieldTextType: boolean;
  data;
  userName;
  userId;
  userURL;

  @Output() toggleSideNavEvent = new EventEmitter<boolean>();
  // @Output() toggleDocumentNavEvent=new EventEmitter<boolean>();

  constructor(public router: Router,
  private modalService: NgbModal,
   private fb: FormBuilder,
  private masterDataService: MasterDataService,
  private commonMessageService:CommonMessageService,
  private humanResourceService:HumanResourceService,
  private userProfileService:UserProfileService
   ) {}

  ngOnInit(): void {
    this.userProfileService.getprofile().subscribe((resp:any)=>{
      this.getUserProfile();
    });
    this.userName=localStorage.getItem('userFname') + ' ' + localStorage.getItem('userLname');
    this.userId=localStorage.getItem('userid');
    console.log('this.toggleSideNavEvent',this.toggleSideNavEvent);
    this.toggleSideNavEvent.emit(this.toggleSideNav);
     this.initModalForm();
     this.getUserProfile();
  }

  getUserProfile(){
  this.humanResourceService.getProfilePhoto().subscribe((resp:any)=>{
  console.log('user profile',resp);
  if(resp.url){
    this.userURL=resp.url;
  }else{
   this.userURL='../../assets/img/userProfile.png'
  }
  })
  }

  initModalForm(){
   this.changePasswordForm = this.fb.group({
     newPass: ['', [Validators.required]],
     confirmPass: ['', [Validators.required]]
   });
   }

getUserDetials(){
  if(this.changePasswordForm.controls['newPass'].value == this.changePasswordForm.controls['confirmPass'].value){
    this.changePasswordForm.controls.confirmPass.setErrors(null);
    }else{
      this.changePasswordForm.controls.confirmPass.setErrors({'missMatch': true});
    }
}

toggleFieldTextType(){
this.fieldTextType = !this.fieldTextType;
}

  onSaveClick(){
    this.submitted=true;
    this.getUserDetials();
    if(this.changePasswordForm.valid){
     this.data=this.changePasswordForm.controls['newPass'].value;
    this.masterDataService.getChangePassword(this.data).subscribe((res:any)=>{
     console.log('changed password',res);
     this.commonMessageService.swalAlertWithoutIcon('',"Password Changed Successfully.");
     this.closeModel();
    });
    }
  }

  onBarsClick() {
    this.toggleSideNav = !this.toggleSideNav;
    this.toggleSideNavEvent.emit(this.toggleSideNav);
    // this.toggleDocumentSideNav=!this.toggleDocumentSideNav;
    // this.toggleDocumentNavEvent.emit(this.toggleDocumentSideNav);
  }

// Usage: Pass an array of keys to exclude


  onLogoutClick() {
    // localStorage.removeItem('token');
    // localStorage.removeItem('userid');
    // localStorage.removeItem('userType');
    // localStorage.removeItem('id');
    // localStorage.removeItem('reportingPartnerId');
     localStorage.clear();
    this.router.navigateByUrl('login');
  }

  onModalClick(modalContent){
   this.openModal(modalContent);
}

  openModal(content) {
    this.submitted=false;
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'animate__animated animate__slideInUp animate__faster',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalService.open(content, ngbModalOptions).result.then(
      (result) => {
        // this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  closeModel(){
   this.changePasswordForm.reset();
   this.modalService.dismissAll();
  }
}
